import { useCallback, useEffect, useState } from 'react';
import { apiService } from '../services/apiService';
import { ExportTypeOption } from '../types/export';

// Export types are static server config; fetch once per session.
let cached: ExportTypeOption[] | null = null;

interface State {
  types: ExportTypeOption[];
  loading: boolean;
  error: string | null;
}

export function useExportTypes() {
  const [state, setState] = useState<State>({ types: cached ?? [], loading: !cached, error: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (cached) return;
    let cancelled = false;
    setState({ types: [], loading: true, error: null });
    apiService
      .getExportTypes()
      .then(({ types }) => {
        cached = types;
        if (!cancelled) setState({ types, loading: false, error: null });
      })
      .catch((error) => {
        if (!cancelled) setState({ types: [], loading: false, error: error?.response?.data?.message ?? error?.message ?? 'Failed to load export types' });
      });
    return () => {
      cancelled = true;
    };
  }, [attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  return { ...state, retry };
}
